import React, { useMemo } from "react";
import Skeleton from "react-loading-skeleton";
import { TableBody } from "./Table.styles";

interface Props {
  x: number;
  y: number;
  isVisible: boolean;
}

const TablePlaceholder = ({ x, y, isVisible }: Props) => {
  const mapped = useMemo(() => {
    return Array.from(Array(y < 5 ? 5 : y)).map(() => {
      const row = {};
      Array.from(Array(x)).forEach((_, k) => (row[k] = 2));
      return row;
    });
  }, [x, y]);

  return (
    <TableBody isVisible={isVisible}>
      {mapped.map((row, key) => (
        <tr key={key}>
          {Object.entries(row).map(([k]) => (
            <td key={`${key}_${k}`}>
              <Skeleton />
            </td>
          ))}
        </tr>
      ))}
    </TableBody>
  );
};

export default React.memo(TablePlaceholder);
